/**
 * What should have happened, against what did: drawn as one contrast, two columns that
 * differ only in the weight of the rule beside them.
 */

import { cn } from '@/lib/utils';

const Side = ({ label, text, accent }: { label: string; text: string; accent: 'intent' | 'outcome' }) => (
  <div
    className={cn(
      'flex min-w-0 flex-1 flex-col gap-1 border-l-2 pl-3',
      accent === 'intent' ? 'border-indigo-500' : 'border-ink'
    )}
  >
    <span className='text-[11px] font-medium tracking-wide text-gray-800 uppercase'>{label}</span>
    <p className='text-[13px] leading-5 text-text-body'>{text}</p>
  </div>
);

export const ExpectedActual = ({
  expected,
  actual,
  /** `stacked` keeps the two in one column: the thread is too narrow to read them side by side. */
  layout = 'auto',
}: {
  expected: string | null;
  actual: string | null;
  layout?: 'auto' | 'stacked';
}) => {
  if (!expected && !actual) return null;
  return (
    <div className={cn('flex flex-col gap-4', layout === 'auto' && 'sm:flex-row sm:gap-6')}>
      {expected && <Side label='Expected' text={expected} accent='intent' />}
      {actual && <Side label='Actual' text={actual} accent='outcome' />}
    </div>
  );
};
